module.exports = __webpack_public_path__ + "img/footer-logo-text.fc0b64a4.png";